import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import service from '../../apis/service';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, notifySuccess, searchArray } from '../utils/Utils';
import Theme from '../ui/Theme';
import AddNewJourneyErrorPopup from './AddNewJourneyErrorPopup';
import RuleJourneyItem from './RuleJourneyItem';
import { apiEndpoints } from '../../constants/apiEndpoints';

const customStyles = {
  content: {
    height: '550px',
    width: '455px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '15px',
  },
};
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
    marginRight: '28px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  content: {
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  searchText: {
    width: '410px',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  scrollContent: {
    marginTop: '20px',
    width: '100%',
    maxHeight: '310px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
}));

export default function AddNewJourneyToRulePopup({ close, ruleId, refreshData }) {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [journeyList, setJourneyList] = useState([]);

  const [searchJourneyVal, setSearchJourneyVal] = useState('');
  const [filterJourneyArray, setFilterJourneyArray] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const getJourneyList = async (id) => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.RULES_JOURNEYS.replace('ID', id))
      .then((response) => {
        setJourneyList(response || []);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  useEffect(() => {
    getJourneyList(ruleId);
  }, [ruleId]);

  useEffect(() => {
    setSearchJourneyVal('');
    setFilterJourneyArray(journeyList);
  }, [journeyList]);

  const handleSearchJourneys = (e) => {
    const input = e.target.value;
    setSearchJourneyVal(input);
    const filteredIArray = searchArray(journeyList, ['title'], input);
    setFilterJourneyArray(filteredIArray);
  };

  const handleCheckBoxChange = (journeyId) => {
    const temp = [...journeyList];
    const jIndex = temp.findIndex((i) => i.id === journeyId);
    temp[jIndex].checked = !temp[jIndex].checked;
    setJourneyList(temp);
  };

  const addJourneysToRule = (overridePopup = false) => {
    const belongsToOtherRule = [];
    const belongsToRoleMapping = [];
    const clickedJourneys = journeyList?.reduce((acc, val) => {
      if (val.checked) {
        acc.push(val.id);
        if (val.isOtherRule) {
          belongsToOtherRule.push(val);
        }
        if (val.isRoleMapped) {
          belongsToRoleMapping.push(val);
        }
      }
      return acc;
    }, []);

    if (!overridePopup && (belongsToOtherRule.length || belongsToRoleMapping.length)) {
      setShowErrorPopup(true);
    } else {
      saveJourney(clickedJourneys);
    }
  };

  const saveJourney = async (clickedJourneys) => {
    dispatch(showProgress(true));
    await service
      .post(apiEndpoints.RULES_JOURNEYS_UPDATE.replace('ID', ruleId), {
        journeyIds: clickedJourneys,
      })
      .then(() => {
        notifySuccess('Journeys mapped Successfully');
        refreshData();
        setShowErrorPopup(false);
        close();
        dispatch(showProgress(false));
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };

  return (
    <Modal isOpen onRequestClose={close} style={customStyles}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={11}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              Add Journeys
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={close} />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={12} className={classes.content}>
          <Grid container direction="column">
            <Grid item>
              <Grid container direction="row" style={{ marginTop: '10px', marginLeft: '5px' }}>
                <Grid item>
                  <TextField
                    id="searchId"
                    name="search"
                    required
                    autoComplete="off"
                    autoSave="off"
                    onChange={handleSearchJourneys}
                    placeholder="Search journeys"
                    value={searchJourneyVal}
                    InputProps={{
                      disableUnderline: true,
                      className: classes.searchText,
                    }}
                    rows={1}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={classes.scrollContent}>
              {filterJourneyArray.map((j) => (
                <RuleJourneyItem journey={j} key={j.id} handleCheckBoxChange={handleCheckBoxChange} />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" style={{ marginTop: '50px' }}>
        <Button variant="contained" className={classes.popCancelBtn} onClick={close}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.popSubmitBtn}
          onClick={() => addJourneysToRule(false)}
        >
          Save
        </Button>
      </Grid>
      {showErrorPopup && (
        <AddNewJourneyErrorPopup
          close={() => setShowErrorPopup(false)}
          accept={() => addJourneysToRule(true)}
          journeyList={journeyList}
        />
      )}
    </Modal>
  );
}
